import { userPlanAtom } from 'app/atoms';
import { hasSignal, Signal } from 'app/network/signals';
import type { ResponseWithSignals } from 'app/network/signals';
import { useAtomValue } from 'jotai';

export enum LPCEvent {
  Dragon2024,
}

export function useIsEventActive(event: LPCEvent) {
  const userPlan = useAtomValue(userPlanAtom);

  const isDragon2024Event = () =>
    hasSignal((userPlan === null ? undefined : userPlan[0]) as ResponseWithSignals | undefined, Signal.Dragon2024);

  switch (event) {
    case LPCEvent.Dragon2024:
      return isDragon2024Event;
  }
}
